// Author Lin
// Date 2022-06-15 16:35:44

class SithMesInventoryManualStorageType {
constructor({
        id = null,
        storageCode = '',
        storageName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.storageCode = storageCode;
    this.storageName = storageName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryManualStorageType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'storageCode',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.grid.storageCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'storageName',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.grid.storageName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    storageCodeFilter : '',
    storageNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'storageCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.filter.storageCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'storageNameFilter',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.filter.storageName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'storageCode',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.entity.storageCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'storageName',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.entity.storageName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualStorageType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryManualStorageType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
